var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarningDeprecated = function SvgWarningDeprecated(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    fillRule: "evenodd",
    d: "M2 9.27V3.05L9 1l7 2.05v6.22C16 15.63 9 17 9 17s-7-1.37-7-7.73M8.92 4.4c-.57.04-.99.54-.94 1.11l.32 4c.03.35.3.62.65.65h.06c.37 0 .68-.28.71-.65l.32-4v-.16a1.06 1.06 0 0 0-1.12-.95m.96 7.72a.88.88 0 1 1-1.76 0 .88.88 0 0 1 1.76 0",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarningDeprecated);
export { ForwardRef as Icon };
export default "img/e2e/warning-deprecated.ae3295c.svg";